import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isRequestCanceled } from "../Common/isRequestCanceled";

/** True when a toast message is just an abort/cancel — never show these. */
function isCanceledToastMessage(msg) {
  if (msg == null || msg === "") return false;
  if (isRequestCanceled(msg)) return true;
  const text = String(
    typeof msg === "string" ? msg : msg?.message || msg?.payload || msg,
  )
    .trim()
    .toLowerCase();
  return (
    text === "canceled" ||
    text === "cancelled" ||
    text === "request was canceled" ||
    text === "request was cancelled" ||
    text.includes("request canceled") ||
    text.includes("request cancelled") ||
    text.includes("operation canceled") ||
    text.includes("operation cancelled")
  );
}

export const ToastifyAlert = (msg, type, show_time) => {
  // API abort/cancel must never surface as a toast (any type).
  if (isCanceledToastMessage(msg)) return;

  const options = {
    position: "top-right",
    transition: Slide,
    autoClose: show_time ? show_time : 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
    theme: "dark",
  };
  // console.log(msg, type);

  switch (type) {
    case "error":
      toast.error(msg, options);
      break;

    case "success":
      toast.success(msg, options);
      break;

    case "info":
      toast.info(msg, options);
      break;

    case "warn":
      toast.warn(msg, options);
      break;

    default:
      break;
  }
};
